import { Column } from 'src/shared/components/Semantic/all'

export const DocumentField = ({
  label,
  value,
}: {
  label: string
  value: string
}) => (
  <Column className="gap-0.5">
    <span className="text-xs uppercase tracking-wide text-muted-foreground">
      {label}
    </span>
    <span className="text-sm font-medium text-foreground">{value}</span>
  </Column>
)
